// extracted by mini-css-extract-plugin
export default {"box":"box--b8a682ec53cd2d9bff2f","title":"title--e8f625a2ee501aa91824","body":"body--e998cf0a1be42219090f"};